// extracted by mini-css-extract-plugin
export default {"title":"L5-z","warning":"M5-z","sizeOptionsLegendText":"N5-z"};